import React, {Component} from "react";
import {Form, Segment} from "semantic-ui-react";
import {Fields} from "./Field";
import {withTranslation} from 'react-i18next'

class ChoiceStep extends Component {

  constructor({step}) {
    super()
    this.state = {step}
  }

  componentWillReceiveProps = ({step}) => {
    this.setState({step})
  }

  handleChange = (e, {value}) => {
    this.forceUpdate()
    this.props.onChange(this.state.step)
  }

  render() {
    let {step} = this.state
    const {t} = this.props;

    return (
      <Form className="pb3" key={step.SortOrder}>
        <label className="black b">{t("general.valueInput")}</label>
        <Segment className="pb3 pt1">
          <Fields step={step} onChange={this.handleChange}/>
        </Segment>
      </Form>
    )
  }
}

export default withTranslation()(ChoiceStep)


// WEBPACK FOOTER //
// ./src/pages/components/Step/ChoiceStep.js